import { Component, Input } from "@angular/core";
import { ServiceHelper } from "../../helper/services.helper";

@Component({
    selector: 'app-help-icon',
    templateUrl: './help-icon.component.html',
    styleUrls: ['./help-icon.component.scss'],
})
export class HelpIconComponent {
    
    @Input() helpText?: string;
    @Input() clickAction?: () => void;
    @Input() title?: string;
    @Input() small?: boolean;
    

    showHelp(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.clickAction) {
           this.clickAction();
        } else {
            ServiceHelper.displayAlert(this.title ?? 'Help', this.helpText ?? 'No help text provided');
        }
    }

}